exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cretaeProcessMainContent {\n  padding-top: 5%;\n  text-align: center; }\n  .cretaeProcessMainContent input,\n  .cretaeProcessMainContent textarea,\n  .cretaeProcessMainContent label {\n    text-align: left; }\n  .cretaeProcessMainContent .card .card-body {\n    padding: 10%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/app/createProcess/createProcess.component.scss
// module id = ../../../../../src/app/createProcess/createProcess.component.scss
// module chunks = main